import { render, staticRenderFns } from "./ContactsBlock.vue?vue&type=template&id=18497eaa&scoped=true&"
import script from "./ContactsBlock.vue?vue&type=script&lang=js&"
export * from "./ContactsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ContactsBlock.vue?vue&type=style&index=0&id=18497eaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18497eaa",
  null
  
)

export default component.exports